import { Dialog } from "@mui/material";
import { styled } from "@mui/system";

export const ModalWrapper = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    display: "flex",
    width: "400px",
    padding: "16px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "12px",
    borderRadius: "8px",
    background: "#FFF",
  },
  boxShadow: "0px 4px 20px 0px rgba(173, 192, 203, 0.30)",
  background: "rgba(0, 32, 53, 0.7)",
}));

export const BrokerInfoWrapper = styled("div")(() => ({
  display: "flex",
  padding: "0px 8px",
  alignItems: "flex-start",
  gap: "12px",
  alignSelf: "stretch",
  justifyContent: "space-between",
  borderRadius: "4px",
}));

export const BrokerContentWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "12px",
  alignSelf: "stretch",
}));

export const BrokerStatusWrapper = styled("div")(() => ({
  display: "flex",
  padding: "0px 8px",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
}));

interface StatusBadgeProps {
  color: string;
}
export const StatusBadge = styled("div")(({ color }: StatusBadgeProps) => ({
  width: "8px",
  height: "8px",
  borderRadius: "8.889px",
  background: color,
}));

interface ContactTextProps {
  isLink?: boolean;
}
export const ContactText = styled("div")(({ isLink }: ContactTextProps) => ({
  color: isLink ? "#FC4C4C" : "#002035",
  fontFamily: "Roobert",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  textDecorationLine: isLink ? "underline" : "none",
}));

export const ContactSubtitle = styled("div")(() => ({
  alignSelf: "stretch",
  color: "#002035",
  fontFamily: "Söhne",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "14px",
}));

export const ContactWrapper = styled("div")(() => ({
  display: "flex",
  padding: "12px 8px",
  flexDirection: "column",
  alignItems: "flec-start",
  gap: "12px",
  alignSelf: "stretch",
  borderRadius: "0px",
  borderTop: "1px solid #E5E7E8",
  background: "#FFF",
}));

export const ContactDetailsWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",
}));

export const EmailWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
}));

export const PhoneNumbersWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",
}));

export const PhoneNumberValues = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4px",
  flex: "1 0 0",
}));

export const PhoneNumberRow = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
}));

interface IconWrapperProps {
  background?: string;
  border?: string;
}
export const IconWrapper = styled("div")(({ background, border }: IconWrapperProps) => ({
  display: "flex",
  padding: "4px",
  alignItems: "center",
  gap: "4px",
  borderRadius: "4px",
  background: background ?? "",
  border: border ?? "",
}));

interface TooltipProps {
  show: boolean;
}
export const Tooltip = styled("div")(({ show }: TooltipProps) => ({
  padding: "12px 16px",
  display: "inline-flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "12px",
  borderRadius: "10px",
  background: "rgba(0, 32, 53, 0.80)",
  color: "#FFF",
  fontFamily: "Söhne",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "14px",
  position: "absolute",
  bottom: 80,
  right: 5,
  zIndex: 1,

  // smooth display transition
  transition: "opacity 0.2s linear, visibility 1s ease",
  opacity: show ? 1 : 0,
  visibility: show ? "visible" : "hidden",
}));
